export default "__VITE_ASSET__CgcaXvEB__"